import React from "react"

import * as headerWithImageStyles from "../../styles/world_championships/HeaderWithImage.module.css"

import { ChildSelector } from "../../helpers/ChildSelector"

import WPImage from "../_base/WPImage"

export default function HeaderWithImage(props) {
  const { content } = props

  const headingPrimary = ChildSelector.select(
    content,
    `header-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const headingSecondary = ChildSelector.select(
    content,
    `header-subtitle`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const description = ChildSelector.select(
    content,
    `header-description`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const highlightText1 = ChildSelector.select(
    content,
    `header-highlight-1`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const highlightText2 = ChildSelector.select(
    content,
    `header-highlight-2`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const callToAction = ChildSelector.select(
    content,
    `header-cta`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  
  return (
    <section 
      id="hero-section" 
      className={`${headerWithImageStyles.heroSection} ${props.className || ''}`}
    >
      <div className={headerWithImageStyles.overlay}></div>
      <div className={headerWithImageStyles.content}>
        <div className={headerWithImageStyles.imageContainer}>
          <WPImage
            holder={content}
            selector={`header-image`}
            className={headerWithImageStyles.heroImage}
          />
        </div>
        {headingPrimary && (
          <h1 
            className={headerWithImageStyles.title}
            dangerouslySetInnerHTML={{ __html: headingPrimary }}
          />
        )}
        {headingSecondary && (
          <p 
            className={headerWithImageStyles.subtitle}
            dangerouslySetInnerHTML={{ __html: headingSecondary }}
          />
        )}
        <div className={headerWithImageStyles.highlights}>
          {highlightText1 && (
            <p className={headerWithImageStyles.highlight}>
              <span className={headerWithImageStyles.highlightIcon}>💡</span>
              <span dangerouslySetInnerHTML={{ __html: highlightText1 }} />
            </p>
          )}
          {highlightText2 && (
            <p className={headerWithImageStyles.highlight}>
              <span className={headerWithImageStyles.highlightIcon}>⚔️</span>
              <span dangerouslySetInnerHTML={{ __html: highlightText2 }} />
            </p>
          )}
        </div>
        {callToAction && (
          <p 
            className={headerWithImageStyles.callToAction}
            dangerouslySetInnerHTML={{ __html: callToAction }}
          />
        )}
      </div>
    </section>
  )
}
